// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prediction_topbar {
    display: flex;

}

.engine_life {
    background-color: white;
    display: flex;
    flex-direction: column;
    width: 9vw;
    box-shadow: 20px 0px 24px rgba(0, 0, 0, 0.02);
    border-top: 2px solid #93BA45;
    /* padding: 1vmax; */
    padding-left: 0.8vw;
    padding-top: 1vh;

    padding-right: 0.8vw;
    /* height: 19vh; */

}

.engine_life_head {
    /* margin-top: -1vh; */
    /* margin-left: 0.1vw; */
    font-size: 0.9vw;
    font-weight: 600;
    line-height: 25px;
}

.engine_recall_no {
    font-weight: 400;
    font-size: 0.6vw;
    color: #76787A;
    margin-top: 1vh;
    letter-spacing: 0.045em;

}

.engine_life_numb {
    font-weight: 400;
    font-size: 0.8vmax;
    margin-top: 2vh;
    /* margin-left: 1vw; */
    color: #76787A;
}

.engine_life_weeks {
    width: 6vw;
    height: 6vh;
    margin-left: 1.5vw;
    margin-top: 3vh;
    /* padding-bottom: 5vh; */
}

.live_data {
    background-color: white;
    margin-left: 1vw;
    width: 41.3vw;
    border-top: 2px solid #93BA45;
    display: flex;
    flex-direction: column;
}

.live_sensor_title {
    margin-top: 1vh;
    margin-left: 1.3vw;
    font-weight: 600;
    font-size: 0.8vw;
    line-height: 22px;
}

.engine_container{
    display: flex;
    width: 37vw;
    overflow-x: scroll;
    padding: 0.9vmax;
    padding-top: 1vh;
    margin-right: 1vw;
    margin-left: 0.5vw;
    margin-top: 0vh;
    height: 20vh;
}

.engine_container::-webkit-scrollbar {
    display: none;
}

.engine_container {
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}

.card,
.card3 {
    border: 0.7px solid #E8E8E8;
    border-radius: 12px;
    padding: 1vw;
    margin-right: 1vw;
    padding-top: 0.1vh;
    padding-bottom: 0.5vh;
    text-align: center;
    margin-right: '1vw';
    display: flex;
    flex-direction: column;
    height: 100%;
}


.card_header {
    font-size: 0.6vw;
    font-weight: 600;
}

.card_detail {
    font-weight: 700;
    font-size: 0.7vw;
    color: #6EB2E3;
    margin-top: 1.4vh;
    border: 0.7px solid rgba(0, 0, 0, 0.34);
    border-radius: 50%;
    padding: 1vw;
    width: 2.4vw;
    height: 4vh;
    margin: 1vw;
    display: flex;
    justify-content: center;
    align-items: center;
}

.card_unit {
    color: rgba(0, 0, 0, 0.34);
    margin-top: 0.5vh;
    font-size: 0.7vw;
    font-weight: 600;
}

.engine_trend {
    background-color: white;
    margin-top: 1.5vh;
    width: 51vw;
    box-shadow: 20px 0px 24px rgba(0, 0, 0, 0.02);
    /* border-radius: 14px; */
    padding: 1vmax;
    border-top: 2px solid #93BA45;
    height: 37.6vh;
}

.engine_trend_head {
    font-weight: 600;
    font-size: 0.9vw;
}


.engine_trend_detail {
    margin-top: 1vh;
    display: flex;
    justify-content: space-between;
}

.engine_trend_left {
    font-size: 0.6vw;
}

.in_weeks {
    opacity: 0.5;
}

.engine_trend_right {
    display: flex;
    font-size: 12px;
}

.good_color_box {
    width: 14px;
    height: 14px;
    background: #98B642;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 32px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    margin-right: 0.5vw;
}

.mode_color_box {
    width: 14px;
    height: 14px;
    background: #FFD44A;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 32px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    margin-right: 0.5vw;
}

.crit_color_box {
    width: 14px;
    height: 14px;
    background: #FF7777;
    ;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 32px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    margin-right: 0.5vw;
}

.trend_condition_text {
    margin-top: -0.3vh;
    margin-right: 0.8vw;
}

.line_chart_live {
    margin-top: 1vh;
    background-color: white;
    display: inline;
}

.prediction_topbar {
    display: flex;

}



.live_data_header {
    display: flex;
    justify-content: space-between;
}

.scroll_arrows {
    display: flex;
    margin-right: 20px;
    cursor: pointer;
    margin-top: 10px;
    -webkit-user-select: none;
            user-select: none;
}

.left_scroll_arrow {
    margin-right: 7px;
}

/* .intake_air_temp {
    margin-top: 2vh;
    padding-top: 3vh;
    padding-bottom: 3vh;
    padding-left: 0.1vw;
    padding-right: 0.1vw;
}
.iarc {
    margin-top: 1.5vh;
}
.air_flow_speed {
    margin-top: 2.3vh;
    padding-top: 2.7vh;
    padding-bottom: 2.7vh;
    padding-left: 1.2vw;
    padding-right: 1.2vw;

}
.afsu {
    margin-top: 1.5vh;
}

.throttle_pos {
    margin-top: 2.5vh;
    padding-top: 2.7vh;
    padding-bottom: 2.7vh;
    padding-left: 1.2vw;
    padding-right: 1.2vw;
}
.tpu {
    margin-top: 1.5vh;
}
.accelerometer_chasis {
    padding-top: 2.6vh;
    padding-bottom: 2.6vh;
}
.fcu {
    margin-top: 1vh;
}
.tire_pressure {
    margin-top: 2vh;
}
.battery_percentage_show {
    margin-top: 3.7vh;
    margin-bottom: 1.5vh;
    padding-top: 2.4vh;
    padding-bottom: 2.4vh;
}

.battery_volts_unit {
    margin-top: 5.5vh;
    margin-bottom: 1.7vh;
} */`, "",{"version":3,"sources":["webpack://./src/Components/ModelBoard/Predictive/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;;AAEjB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,6CAA6C;IAC7C,6BAA6B;IAC7B,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;;IAEhB,oBAAoB;IACpB,kBAAkB;;AAEtB;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,uBAAuB;;AAE3B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;IAEI,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;;AAGA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,uCAAuC;IACvC,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,6CAA6C;IAC7C,yBAAyB;IACzB,cAAc;IACd,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;;AAGA;IACI,eAAe;IACf,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,8EAA8E;IAC9E,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,8EAA8E;IAC9E,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;;IAEnB,8EAA8E;IAC9E,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;;AAEjB;;;;AAIA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAoDG","sourcesContent":[".prediction_topbar {\r\n    display: flex;\r\n\r\n}\r\n\r\n.engine_life {\r\n    background-color: white;\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 9vw;\r\n    box-shadow: 20px 0px 24px rgba(0, 0, 0, 0.02);\r\n    border-top: 2px solid #93BA45;\r\n    /* padding: 1vmax; */\r\n    padding-left: 0.8vw;\r\n    padding-top: 1vh;\r\n\r\n    padding-right: 0.8vw;\r\n    /* height: 19vh; */\r\n\r\n}\r\n\r\n.engine_life_head {\r\n    /* margin-top: -1vh; */\r\n    /* margin-left: 0.1vw; */\r\n    font-size: 0.9vw;\r\n    font-weight: 600;\r\n    line-height: 25px;\r\n}\r\n\r\n.engine_recall_no {\r\n    font-weight: 400;\r\n    font-size: 0.6vw;\r\n    color: #76787A;\r\n    margin-top: 1vh;\r\n    letter-spacing: 0.045em;\r\n\r\n}\r\n\r\n.engine_life_numb {\r\n    font-weight: 400;\r\n    font-size: 0.8vmax;\r\n    margin-top: 2vh;\r\n    /* margin-left: 1vw; */\r\n    color: #76787A;\r\n}\r\n\r\n.engine_life_weeks {\r\n    width: 6vw;\r\n    height: 6vh;\r\n    margin-left: 1.5vw;\r\n    margin-top: 3vh;\r\n    /* padding-bottom: 5vh; */\r\n}\r\n\r\n.live_data {\r\n    background-color: white;\r\n    margin-left: 1vw;\r\n    width: 41.3vw;\r\n    border-top: 2px solid #93BA45;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.live_sensor_title {\r\n    margin-top: 1vh;\r\n    margin-left: 1.3vw;\r\n    font-weight: 600;\r\n    font-size: 0.8vw;\r\n    line-height: 22px;\r\n}\r\n\r\n.engine_container{\r\n    display: flex;\r\n    width: 37vw;\r\n    overflow-x: scroll;\r\n    padding: 0.9vmax;\r\n    padding-top: 1vh;\r\n    margin-right: 1vw;\r\n    margin-left: 0.5vw;\r\n    margin-top: 0vh;\r\n    height: 20vh;\r\n}\r\n\r\n.engine_container::-webkit-scrollbar {\r\n    display: none;\r\n}\r\n\r\n.engine_container {\r\n    -ms-overflow-style: none;\r\n    /* IE and Edge */\r\n    scrollbar-width: none;\r\n    /* Firefox */\r\n}\r\n\r\n.card,\r\n.card3 {\r\n    border: 0.7px solid #E8E8E8;\r\n    border-radius: 12px;\r\n    padding: 1vw;\r\n    margin-right: 1vw;\r\n    padding-top: 0.1vh;\r\n    padding-bottom: 0.5vh;\r\n    text-align: center;\r\n    margin-right: '1vw';\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n}\r\n\r\n\r\n.card_header {\r\n    font-size: 0.6vw;\r\n    font-weight: 600;\r\n}\r\n\r\n.card_detail {\r\n    font-weight: 700;\r\n    font-size: 0.7vw;\r\n    color: #6EB2E3;\r\n    margin-top: 1.4vh;\r\n    border: 0.7px solid rgba(0, 0, 0, 0.34);\r\n    border-radius: 50%;\r\n    padding: 1vw;\r\n    width: 2.4vw;\r\n    height: 4vh;\r\n    margin: 1vw;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.card_unit {\r\n    color: rgba(0, 0, 0, 0.34);\r\n    margin-top: 0.5vh;\r\n    font-size: 0.7vw;\r\n    font-weight: 600;\r\n}\r\n\r\n.engine_trend {\r\n    background-color: white;\r\n    margin-top: 1.5vh;\r\n    width: 51vw;\r\n    box-shadow: 20px 0px 24px rgba(0, 0, 0, 0.02);\r\n    /* border-radius: 14px; */\r\n    padding: 1vmax;\r\n    border-top: 2px solid #93BA45;\r\n    height: 37.6vh;\r\n}\r\n\r\n.engine_trend_head {\r\n    font-weight: 600;\r\n    font-size: 0.9vw;\r\n}\r\n\r\n\r\n.engine_trend_detail {\r\n    margin-top: 1vh;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.engine_trend_left {\r\n    font-size: 0.6vw;\r\n}\r\n\r\n.in_weeks {\r\n    opacity: 0.5;\r\n}\r\n\r\n.engine_trend_right {\r\n    display: flex;\r\n    font-size: 12px;\r\n}\r\n\r\n.good_color_box {\r\n    width: 14px;\r\n    height: 14px;\r\n    background: #98B642;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 32px rgba(0, 0, 0, 0.04);\r\n    border-radius: 3px;\r\n    margin-right: 0.5vw;\r\n}\r\n\r\n.mode_color_box {\r\n    width: 14px;\r\n    height: 14px;\r\n    background: #FFD44A;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 32px rgba(0, 0, 0, 0.04);\r\n    border-radius: 3px;\r\n    margin-right: 0.5vw;\r\n}\r\n\r\n.crit_color_box {\r\n    width: 14px;\r\n    height: 14px;\r\n    background: #FF7777;\r\n    ;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 32px rgba(0, 0, 0, 0.04);\r\n    border-radius: 3px;\r\n    margin-right: 0.5vw;\r\n}\r\n\r\n.trend_condition_text {\r\n    margin-top: -0.3vh;\r\n    margin-right: 0.8vw;\r\n}\r\n\r\n.line_chart_live {\r\n    margin-top: 1vh;\r\n    background-color: white;\r\n    display: inline;\r\n}\r\n\r\n.prediction_topbar {\r\n    display: flex;\r\n\r\n}\r\n\r\n\r\n\r\n.live_data_header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.scroll_arrows {\r\n    display: flex;\r\n    margin-right: 20px;\r\n    cursor: pointer;\r\n    margin-top: 10px;\r\n    user-select: none;\r\n}\r\n\r\n.left_scroll_arrow {\r\n    margin-right: 7px;\r\n}\r\n\r\n/* .intake_air_temp {\r\n    margin-top: 2vh;\r\n    padding-top: 3vh;\r\n    padding-bottom: 3vh;\r\n    padding-left: 0.1vw;\r\n    padding-right: 0.1vw;\r\n}\r\n.iarc {\r\n    margin-top: 1.5vh;\r\n}\r\n.air_flow_speed {\r\n    margin-top: 2.3vh;\r\n    padding-top: 2.7vh;\r\n    padding-bottom: 2.7vh;\r\n    padding-left: 1.2vw;\r\n    padding-right: 1.2vw;\r\n\r\n}\r\n.afsu {\r\n    margin-top: 1.5vh;\r\n}\r\n\r\n.throttle_pos {\r\n    margin-top: 2.5vh;\r\n    padding-top: 2.7vh;\r\n    padding-bottom: 2.7vh;\r\n    padding-left: 1.2vw;\r\n    padding-right: 1.2vw;\r\n}\r\n.tpu {\r\n    margin-top: 1.5vh;\r\n}\r\n.accelerometer_chasis {\r\n    padding-top: 2.6vh;\r\n    padding-bottom: 2.6vh;\r\n}\r\n.fcu {\r\n    margin-top: 1vh;\r\n}\r\n.tire_pressure {\r\n    margin-top: 2vh;\r\n}\r\n.battery_percentage_show {\r\n    margin-top: 3.7vh;\r\n    margin-bottom: 1.5vh;\r\n    padding-top: 2.4vh;\r\n    padding-bottom: 2.4vh;\r\n}\r\n\r\n.battery_volts_unit {\r\n    margin-top: 5.5vh;\r\n    margin-bottom: 1.7vh;\r\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
